import React, { useCallback } from 'react';
import Button from '@atlaskit/button';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { messages } from './messages.tsx';
import type { FeedbackButtonProps } from './types.tsx';

export const FeedbackButton = ({ feedbackDialogAttributes }: FeedbackButtonProps) => {
	const { formatMessage } = useIntl();
	const { openFeedbackCollector } = useFeedbackCollectorActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClick = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'navigationItem',
			}),
			'sidebar',
			{ itemId: 'feedback-footer' },
		);
		openFeedbackCollector({
			...feedbackDialogAttributes,
		});
	}, [createAnalyticsEvent, feedbackDialogAttributes, openFeedbackCollector]);

	return (
		<Button appearance="subtle-link" onClick={onClick} spacing="none">
			{formatMessage(messages.feedback)}
		</Button>
	);
};
